const PrivacyPolicy = () => import("@/views/policy/PrivacyPolicy.vue")
const CookiePolicy = () => import("@/views/policy/CookiePolicy.vue")

export default [
  {
    path: 'privacy-policy',
    name: 'privacy-policy',
    component: PrivacyPolicy
  },
  {
    path: 'cookie-policy',
    name: 'cookie-policy',
    component: CookiePolicy
  },
]